<template>
  <nav class="navbar">
    <div class="container-fluid d-flex justify-content-between align-items-center">
      <button
        class="navbar-toggler"
        type="button"
        @click="toggleSidebar"
        aria-label="Toggle sidebar"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="profile-section ms-auto">
        <div class="dropdown">
          <img
            src="https://via.placeholder.com/50"
            alt="User Avatar"
            class="dropdown-toggle rounded-circle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            style="cursor: pointer; width: 50px; height: 50px;"
          />
          <ul class="dropdown-menu dropdown-menu-end">
            <li><a class="dropdown-item" @click="goToProfile">Profile</a></li>
            <li><a class="dropdown-item" @click="goToChangePassword">Change Password</a></li>
            <li><hr class="dropdown-divider" /></li>
            <li><a class="dropdown-item text-danger" @click="logout">Logout</a></li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { useRouter } from 'vue-router';

export default {
  name: 'AppNavbar',
  setup() {
    const router = useRouter();

    // Function to toggle the sidebar
    const toggleSidebar = () => {
      document.body.classList.toggle('sidebar-open'); // Toggle 'sidebar-open' class on body
    };

    const goToProfile = () => {
      router.push({ name: 'profilePage' });
    };

    const goToChangePassword = () => {
      router.push({ name: 'changePasswordPage' });
    };

    const logout = () => {
      localStorage.removeItem('authToken');
      router.push({ name: 'loginPage' });
    };

    return {
      toggleSidebar,
      goToProfile,
      goToChangePassword,
      logout,
    };
  },
};
</script>

<style scoped>
.navbar {
  background-color: #1e293b;
  color: #ffffff;
  padding: 10px;
  border-bottom: 1px solid #444;
}

.navbar-toggler {
  border: none;
  color: #ffffff;
}

/* Custom style for the toggle icon */
.navbar-toggler-icon {
  background-image: none;
  display: inline-block;
  width: 24px;
  height: 2px;
  background-color: #ffffff;
  position: relative;
  transition: all 0.3s ease-in-out;
}

.navbar-toggler-icon::before,
.navbar-toggler-icon::after {
  content: '';
  display: inline-block;
  width: 24px;
  height: 2px;
  background-color: #ffffff;
  position: absolute;
  left: 0;
  transition: all 0.3s ease-in-out;
}

.navbar-toggler-icon::before {
  top: -8px;
}

.navbar-toggler-icon::after {
  top: 8px;
}

.dropdown-menu {
  min-width: 200px;
  background-color: #2d3748;
}

.dropdown-item {
  color: #ffffff;
}

.dropdown-item:hover {
  background-color: #3b4a60;
}
</style>
